import { createBrowserHistory } from 'history'

function getBasename(): string {
  const match = window.location.pathname.match(/^\/_branch\/[^/]+/)
  return match ? match[0] : ''
}

const history = createBrowserHistory({ basename: getBasename() })

// @ts-ignore - provided for playwright
window.reactRouterHistory = history

export default history
